
import {
  defineComponent,
  computed,
} from 'vue';

import IconCheck from '@/components/inputs/IconCheck.vue';

export default defineComponent({
  emits: ['update:modelValue'],

  components: {
    IconCheck,
  },

  props: {
    modelValue: {
      type: Boolean,
      default: () => false,
    },
    error: {
      type: [String, Array],
      required: false,
      default: () => '',
    },
  },

  setup(props, context) {
    const id = `ioi-${Math.random().toString(36).substr(2, 9)}`;

    const hasError = computed(() => (props.error !== null ? props.error.length > 0 : false));

    const errorMessage = computed(() => {
      if (hasError.value) {
        return Array.isArray(props.error)
          ? props.error[0]
          : props.error;
      }

      return '';
    });

    const value = computed({
      get(): unknown {
        return props.modelValue;
      },
      set(newValue: unknown): void {
        context.emit('update:modelValue', newValue);
      },
    });

    const emitInput = (event: {
      target: {
        checked: boolean,
      }
    }) => {
      value.value = event.target.checked;
    };

    return {
      id,
      value,
      hasError,
      errorMessage,
      emitInput,
    };
  },
});
